// extracted by mini-css-extract-plugin
export default {"textNotific":"Notification_textNotific__TtDNa"};